/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrphanWarningDTO { 
    satellite?: string;
    target_or_categoria?: string;
    chiave?: string;
    ordine?: number;
    message_key?: string;
    message?: string;
}

